import { Injectable } from '@angular/core';
import { EntityState, EntityStore, getEntityType, StoreConfig } from '@datorama/akita';

import { BudgetVersion } from '@shared/services/gql.service';
import { RequireSome } from '@shared/utils/utils';

export type BudgetLibraryModel = getEntityType<BudgetLibraryState>;

export type BudgetLibraryState = EntityState<
  RequireSome<Partial<BudgetVersion>, 'budget_version_id'>
>;

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'budget-library' })
export class BudgetLibraryStore extends EntityStore<BudgetLibraryState> {
  constructor() {
    super({});
  }
}
